module.exports = __webpack_public_path__ + "img/7.c8f1fc23.svg";